import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBbciplayerComponent } from './simple-icons-bbciplayer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBbciplayerComponent ],
    exports:      [ SimpleIconsBbciplayerComponent ],
    bootstrap:    []
})
export class SimpleIconsBbciplayerModule {}
